<template>
	<div style="min-height: 220px; overflow-x: hidden;">
		<k-tabs v-model="selected_tab" style="margin-bottom: 5px;">
        	<k-tab name="stats" label="Stats"></k-tab>
        	<k-tab name="networks" label="Networks"></k-tab>
<!--        	<k-tab name="inputs" label="Inputs"></v-tab>-->
        	<k-tab name="encoders" label="Encoders" v-if="!is_server"></k-tab>
        	<k-tab name="outputs" label="Outputs" v-if="!is_server"></k-tab>
        	<k-tab name="system" label="System" v-if="$is_admin()"></k-tab>
		</k-tabs>

		<div v-if="stats">
<!--
		<div v-if="dense">
			<div v-if="!is_server" class="stats-segment">
				<span class="font-weight-medium">Streamer: </span>
				<k-chip class="ml-2" size="xs" :color="streamer_status_color">{{streamer_status_text}}</k-chip>
			</div>

			<div class="mt-0" v-if="stats.system.load">
				<span class="font-weight-medium">Load: </span>
				<k-chip size="xs">{{stats.system.load.avg1 | format_load}}</k-chip>
				<k-chip size="xs">{{stats.system.load.avg5 | format_load}}</k-chip>
				<k-chip size="xs">{{stats.system.load.avg15 | format_load}}</k-chip>
			</div>
			<div class="mt-0"  v-if="stats.system.cpu">
				<span class="font-weight-medium">CPUs: </span>
				<k-chip size="xs">{{cpu_count}}</k-chip>
				<k-chip size="xs" :color="get_color(cpu_average)">Avg: {{cpu_average | format_cpu}}</k-chip>
				<k-chip size="xs" :color="get_color(cpu_max)">Max: {{cpu_max | format_cpu}}</k-chip>
			</div>

			<div class="mt-0"  v-if="stats.system.mem">
				<k-progress-linear outlined height="19px" :value="get_mem_percent(stats.system.mem)" :color="get_mem_color(stats.system.mem)">
					<strong style="padding-left: 10px;">Mem: {{ get_mem_percent(stats.system.mem) | format_load }} %</strong>
				</k-progress-linear>
			</div>

			<div class="mt-0 mb-3" style="margin: 0 auto; text-align: left;" v-if="stats.system.disk">
				<span class="font-weight-medium mb-3">Disks: </span>
				<template class="my-1" v-for="(disk,name) in stats.system.disk">
					<k-chip size="xs" :color="get_disk_color(disk.used)">{{name}} {{disk.used}}%</k-chip>
				</template>
			</div>

		</div>-->


		<div v-if="!dense">

			<k-layout responsive="650" v-if="selected_tab == 'stats'">
				<k-flex cols="6">

					<div v-if="show_title_and_channel">
<!--						<div class="ks-font-size-l">{{title}}</div>-->
						<div class="mt-3" v-if="!is_server">
							<k-layout>
								<k-flex cols="3">
									<span class="font-weight-medium">Channel</span>
								</k-flex>
								<k-flex cols="9" style="overflow: hidden;">
									<k-chip outlined size="xs" @click.stop="open_channel">{{channel_title_for_instance}}</k-chip>
								</k-flex>
							</k-layout>
						</div>
					</div>

					<div v-if="!is_server" class="stats-segment">
						<k-layout>
							<k-flex cols="3"><span class="font-weight-medium">Streamer</span></k-flex>
							<k-flex cols="9"><k-chip outlined size="xs" :color="streamer_status_color">{{streamer_status_text}}</k-chip></k-flex>
						</k-layout>
					</div>
 			
 					<div v-if="update_status">
 						<k-layout>
 							<k-flex cols="3">
		 						<span class="font-weight-medium">Last update</span>
 							</k-flex>
 							<k-flex cols="9">
		        				<k-chip class="" size="xs" :color="update_status_color" @click.stop="show_update_status = !show_update_status">{{update_status.time}}</k-chip>
		        			</k-flex>
		        		</k-layout>
        				<div v-if="show_update_status" style="background-color: #333; padding: 10px;" class="mt-2 mr-2">
            				<template v-for="msg in update_status.message">
            					<div class="caption">{{msg}}</div>
          					</template>
        				</div>
      				</div>
					<div class="stats-segment">
						<k-layout>
							<k-flex cols="3"><span class="font-weight-medium">Broadcaster</span></k-flex>
							<k-flex cols="9"><k-chip outlined size="xs">{{broadcaster_version}}</k-chip></k-flex>
						</k-layout>
					</div>

					<!-- IP field -->
					<div class="stats-segment">
						<k-layout>
							<k-flex cols="3"><span class="font-weight-medium">IP: </span></k-flex>
							<k-flex cols="9"><k-chip outlined size="xs"> {{ get_field(instance, ['system_info', 'ip'], '') }} </k-chip></k-flex>
						</k-layout>
					</div>

			<!-- Mobile streamer stats -->
					<div>
						<k-layout>
							<k-flex c3>
								<span class="font-weight-medium">System info</span>
							</k-flex>
							<k-flex c9>
								<!-- Battery status -->
								<template v-if="stats.system.battery_percent">
									<k-chip size="xs" :color="get_battery_color(stats.system.battery_percent)" >
										<k-icon style="color: white;">{{get_battery_icon(stats.system.battery_percent)}}</k-icon>{{stats.system.battery_percent}}
									</k-chip>
								</template>

								<template v-if="stats.system.battery_state">
									<!-- Charging status -->
									<k-chip size="xs" :color="get_battery_state_color(stats.system.battery_state)">
										<k-icon style="color: white;" v-if="stats.system.battery_state == 'Charging'">power</k-icon>
										<k-icon style="color: white;" v-else-if="stats.system.battery_state == 'Full'">power</k-icon>
										<k-icon v-else style="color: white;">power_off</k-icon>
									</k-chip>
								</template>

								<template v-if="stats.system.temperature">

									<!-- Battery temperature status -->
									<k-chip size="xs" :color="get_temp_color(stats.system.temperature)" style="color: white;">
										<k-icon>device_thermostat</k-icon>{{stats.system.temperature}}
									</k-chip>
								</template>
							</k-flex>
						</k-layout>
					</div>

					<!-- Other streamers -->

					<!-- Disk stats -->
					<div class="mt-1 mb-2 mr-2" style="margin: 0 auto; text-align: left;" v-if="stats.system.disk">
						<div class="font-weight-medium mb-1">Disks:</div>
						<div class="" v-for="(disk,name) in stats.system.disk" :key="name">
							<k-progress-linear outlined height="19px" style="margin-top: 3px;" :value="disk.used" :color="get_disk_color(disk.used)">
								<k-layout class="ml-2">
									<k-flex cols="2">{{disk.used}} %</k-flex>
									<k-flex cols="8">{{name}}</k-flex>
								</k-layout>
							</k-progress-linear>
						</div>
					</div>
				</k-flex>

				<k-flex cols="6">

					<!-- Load stats -->
					<div class="mt-2" v-if="stats.system.load">
						<k-layout>
							<k-flex cols="3"><span class="font-weight-medium">Load:</span></k-flex>
							<k-flex cols="9">
								<k-chip outlined size="xs">{{stats.system.load.avg1 | format_load}}</k-chip>
								<k-chip outlined size="xs">{{stats.system.load.avg5 | format_load}}</k-chip>
								<k-chip outlined size="xs">{{stats.system.load.avg15 | format_load}}</k-chip>
							</k-flex>
						</k-layout>
					</div>

					<!-- CPU stats -->
					<div class="mt-2"  v-if="stats.system.cpu">
						<span class="font-weight-medium">CPU:</span>
						<div>
							<span v-for="(cpu,num) in stats.system.cpu" :key="'cpu' + num">
								<k-chip outlined size="xs" centered style="width: 40px;":color="get_cpu_color(cpu)">
									{{get_cpu_used(cpu) | format_cpu}}
								</k-chip>
							</span>
						</div>
					</div>

					<!-- Memory stats -->
					<div class="mt-2"  v-if="stats.system.mem">
						<span class="font-weight-medium">Mem:</span>
						<div>
							<k-progress-linear outlined height="19px" :value="get_mem_percent(stats.system.mem)" :color="get_mem_color(stats.system.mem)">
								<span style="padding-left: 10px;">{{ get_mem_percent(stats.system.mem) | format_load }} %</span>
							</k-progress-linear>
						</div>
					</div>
				</k-flex>
			</k-layout>

	<!-- Networks tab -->
	<k-layout v-if="selected_tab == 'networks'">
		<k-flex c12>
			<div class="mt-2" v-if="stats.system.net">
				<div class="font-weight-medium">Network:</div>

				<k-layout class="ks-font-size-s">
					<k-flex c2>Device</k-flex>
					<k-flex c2>IP</k-flex>
					<k-flex c1>GW</k-flex>
					<k-flex c2>Ping</k-flex>
					<k-flex c2>Down</k-flex>
					<k-flex c2>UP</k-flex>
					<k-flex c1>Test status</k-flex>
				</k-layout>


				<template v-for="(info, device) in stats.system.net">
						<k-layout row v-if="device != 'lo'">
							<k-flex c2>
								<k-chip outlined size="xs" style="min-width: 95%;" :color="get_net_color(info, device)">
								<template v-if="info.type">
									<k-icon small style="margin-right: 5px;">{{get_net_icon(info, device)}}</k-icon>
								</template>
								{{device}}
							</k-chip>
							</k-flex>
							<k-flex c2>
								{{info.ip}}
							</k-flex>

							<template v-if="streamer_net_stats && streamer_net_stats[device]">
								<k-flex c1>
									<k-icon small v-if="streamer_net_stats[device].d_gw == true">check</k-icon>
									<template v-else>
										<k-btn small icon v-if="info.ip" style="width: 15px; height: 15px; margin: 0px; padding: 0px;" @click="set_default_interface(device)">
											<k-icon small>settings_ethernet</k-icon>
										</k-btn>
									</template>
								</k-flex>


								<k-flex c2>
									<template v-if="streamer_net_stats[device].p">
										<k-icon small>network_ping</k-icon>{{streamer_net_stats[device].p}}
									</template>
								</k-flex>
								<k-flex c2>
									<template v-if="streamer_net_stats[device].d_r">
										<k-icon small>download</k-icon>{{streamer_net_stats[device].d_r}}
									</template>
								</k-flex>
								<k-flex c2>
									<template v-if="streamer_net_stats[device].u_r">
										<k-icon small>upload</k-icon>{{streamer_net_stats[device].u_r}}
									</template>
								</k-flex>
								<k-flex c1>
									<k-icon small v-if="streamer_net_stats[device].t_q == true">hourglass_empty</k-icon>
									<k-icon small v-if="streamer_net_stats[device].t_i_p == true">sync</k-icon>
									<k-icon small v-if="streamer_net_stats[device].t_s == true">check</k-icon>
								</k-flex>

							</template>
						</k-layout>
						<template v-if="streamer_net_stats && streamer_net_stats[device]">
							<k-layout  v-if="streamer_net_stats[device].t_s == true && streamer_net_stats[device].t_r" style="background-color: rgba(0,0,0,0.3);">
								<k-flex c3>
									{{streamer_net_stats[device].t_r.ts}}
								</k-flex>
								<k-flex c2>
									{{streamer_net_stats[device].t_r.isp}}
								</k-flex>
								<k-flex c2>
									<k-icon small>network_ping</k-icon>{{streamer_net_stats[device].t_r.l}}									
								</k-flex>
								<k-flex c2>
									<k-icon small>download</k-icon>{{streamer_net_stats[device].t_r.dw}}									
								</k-flex>
								<k-flex c2>
									<k-icon small>upload</k-icon>{{streamer_net_stats[device].t_r.up}}									
								</k-flex>
							</k-layout>
						</template>
				</template>
			</div>

		</k-flex>
	</k-layout>


	<!-- Inputs tab -->

<!--
	<k-layout v-if="selected_tab == 'inputs'">
		<k-flex c12>
			{{input_routers_state}}
		</k-flex>
	</k-layout>
-->
	<!-- Encoders tab -->
	<k-layout v-if="selected_tab == 'encoders'">
		<k-flex c12>
			<div class="mt-1 mb-3" style="margin: 0 auto; text-align: left;" v-if="encoders">
				<div class="font-weight-medium mb-1	">Encoders:</div>
				<k-layout row class="ks-font-size-s">
					<k-flex c2>Enc</k-flex>
					<k-flex c4>Name</k-flex>
					<k-flex c2>Current</k-flex>
					<k-flex c2>Config</k-flex>
					<k-flex c2>Set</k-flex>
				</k-layout>

				<div class="my-1" v-for="enc in encoders">
					<k-layout row>
						<k-flex c2>
							<k-chip outlined size="xs">{{trim_encoder_type(enc.config.type)}}</k-chip>
						</k-flex>
						<k-flex c4>
							{{enc.config.name}}
						</k-flex>
						<k-flex c2>
							<k-chip outlined size="xs">{{enc.state.bitrate}}</k-chip>
						</k-flex>
						<k-flex c2>
							<k-chip outlined size="xs" @click.stop="set_bitrate(enc, get_encoder_config_bitrate(enc))" small>{{get_encoder_config_bitrate(enc)}}</k-chip>
						</k-flex>
						<k-flex c1 style="text-align: right">
 							<k-edit-dialog lazy @save="set_bitrate(enc, bitrates[enc.config.name])">
								<k-icon small>settings</k-icon>
				                <template v-slot:input>
                  					<k-text-field placeholder="Bitrate" v-model="bitrates[enc.config.name]"></k-text-field>
<!--                      					<k-btn flat left color="green" @click.stop="set_bitrate(enc, bitrates[enc.config.name])">Save</k-btn>-->
               					</template>
              				</k-edit-dialog>
						</k-flex>

					</k-layout>
				</div>

			</div>
		</k-flex>

	</k-layout>

<!-- Outputs -->
	<k-layout v-if="selected_tab == 'outputs'">
		<k-flex c12>
			<div v-if="output_state" class="ks-font-size-s">
				<k-layout class="ks-title">
					<k-flex c2>Type</k-flex>
					<k-flex c1>Adapter</k-flex>
					<k-flex c1>Run</k-flex>
					<k-flex c3>Qualities</k-flex>
					<k-flex c5>Events</k-flex>
				</k-layout>

				<k-layout v-for="(data, uuid) in output_state.a" :key="uuid">
					<k-flex c2>{{data.type}}</k-flex>
					<k-flex c1>{{data.adapter}}</k-flex>
					<k-flex c1>Always</k-flex>
					<k-flex c6>
						<k-chip outlined size="xs" v-for="(quality, index) in data.qualities" :key="index">{{quality}}</k-chip>
					</k-flex>
				</k-layout>

				<template v-for="(info, event_uuid) in output_state.e">
					<k-layout v-for="(data,uuid) in info" :key="uuid">
						<k-flex c2>{{data.type}}</k-flex>
						<k-flex c1>{{data.adapter}}</k-flex>
						<k-flex c1>Event</k-flex>
						<k-flex c3>
							<k-chip outlined size="xs" v-for="(quality, index) in data.qualities" :key="index">{{quality}}</k-chip>
						</k-flex>
						<k-flex c5>
							{{event_uuid}}
						</k-flex>
					</k-layout>
				</template>

				<template v-for="(info, event_uuid) in output_state.eg">
					<k-layout v-for="(data,uuid) in info" :key="uuid">
						<k-flex c2>{{data.type}}</k-flex>
						<k-flex c1>{{data.adapter}}</k-flex>
						<k-flex c1>EventGrp</k-flex>
						<k-flex c3>
							<k-chip outlined size="xs" v-for="(quality, index) in data.qualities" :key="index">{{quality}}</k-chip>
						</k-flex>
						<k-flex c5>
							{{event_uuid}}
						</k-flex>
					</k-layout>
				</template>

			</div>


			<div v-if="rtmp_state" class="mt-2 mb-3">
				<span class="ks-title">RTMP stats:</span>
				<div class="quality-table">
					<div class="quality-table__header ks-title">
						<!-- <div v-for="header in rtmp_headers" :key="header.text" class="quality-table__header__value" :style="`width: ${header.width}`">{{header.text}}</div> -->
						<div v-for="header in quality_headers" :key="header.text" :style="`width: ${header.width}`" v-tooltip="header.tooltip">
							<div class="quality-table__header__value">{{ header.text }}</div>
						</div>
					</div>

					<div v-tooltip="row.url" v-for="row in rtmp_state" :key="row.url">
						<div class="quality-table__row" :class="['quality-table__row--dark']">
							<div v-for="header in quality_headers" :key="header.value" class="quality-table__value" :style="`width: ${header.width}; padding-top: 0px;`">
								<span small> {{ row[header.value] ? row[header.value].replace('kbits/s', '') : '-' }}</span>
							</div>
						</div>
					</div>

				</div>
			</div>

			<div v-if="srt_state" class="mt-2 mb-3">
				<span class="ks-title">SRT:</span>
				<div class="quality-table">
					<div class="quality-table__header ks-title">
						<!-- <div v-for="header in srt_headers" :key="header.text" class="quality-table__header__value" :style="`width: ${header.width}`">{{header.text}}</div> -->
						<div v-tooltip="header.tooltip" v-for="header in quality_headers" :key="header.text" :style="`width: ${header.width}`">
							<div class="quality-table__header__value">{{ header.text }}</div>
						</div>
					</div>

					<div v-tooltip="row.url" v-for="(row,url) in srt_state" :key="row.url">
						<div class="quality-table__row" :class="['quality-table__row--dark']">
							<div v-for="header in quality_headers" :key="header.value" class="quality-table__value" :style="`width: ${header.width}; padding-top: 0px;`">
								<template v-if="row">
									<template v-if="header.value == 'quality'">{{row[header.value]}}</template>
									<template v-else>
										<template v-if="row.data">
											<span small> {{ row.data[header.value] ? row.data[header.value].replace('kbits/s', '') : '-' }}</span>
										</template>
									</template>
								</template>
							</div>
						</div>
					</div>

				</div>
			</div>


			<div v-if="srtla_state" class="mt-2 mb-3">
				<span class="ks-title">SRTLA:</span>
				<div v-for="output in srtla_state" style="padding-left: 10px;">
					<div class="ks-title">{{output.quality}}:</div>
					<div class="ks-title ks-font-size-s" style="display: grid; grid-template-columns: 200px 100px 100px 100px max-content; padding-left: 10px;">
						<div>Network</div>
						<div>Usage%</div>
						<div>Window</div>
						<div>In flight</div>
						<div>Priority</div>
					</div>


					<div v-for="(state, src) in output.data" class="ks-font-size-s" style="display: grid; grid-template-columns: 200px 100px 100px 100px max-content; padding-left: 10px;">
						<div>{{state.device}} ({{state.src}})</div>
						<div>{{state.usage.toFixed(2)}}</div>
						<div>{{state.window}}</div>
						<div>{{state.in_flight}}</div>
						<div>
							<template v-if="state.priority == 0">Disabled</template>
							<template v-else>
								{{state.priority}}
							</template>
						</div>
					</div>
				</div>
			</div>

			<div v-if="srt_state_router" class="mt-2 mb-3">
				<span class="ks-title">SRT:</span>
				<div>
					<div v-for="stats in srt_state_router" style="padding-left: 10px;">
						<div class="ks-title">{{stats.quality}}:</div>
						<srt-stats :stats="stats.data" type="send" :adaptive-bitrate="stats.bitrate"></srt-stats>
<!--						<k-key-value :items="[{key: 'Calculated adaptive bitrate', value: stats.bitrate / 1000}]" :key-width="'60%'" columns="2">
							<template #value="{value}">
								<k-chip outlined size="xs">{{value}}</k-chip>
							</template>
						</k-key-value>-->
					</div>
				</div>
			</div>



		</k-flex>
	</k-layout>


	<k-layout responsive="650" v-if="selected_tab == 'system'">
		<k-flex c6>
			<div class="mt-2" v-if="stats.system.pressure">
				<span class="ks-title">Pressure:</span>
				<div v-for="(data, key) in stats.system.pressure" :key="key">
					<span class="ks-title">{{key}}:</span>
					<k-layout v-for="(value, type) in data" :key="type">
						<k-flex c3 class="ks-font-size-s">{{type}}</k-flex>
						<k-flex c9>
							<k-layout>
								<k-flex c2><k-chip outlined size="xs" centered style="width: 100%;">{{value.avg10}}</k-chip></k-flex>
								<k-flex c2><k-chip outlined size="xs" centered style="width: 100%;">{{value.avg60}}</k-chip></k-flex>
								<k-flex c2><k-chip outlined size="xs" centered style="width: 100%;">{{value.avg300}}</k-chip></k-flex>
								<k-flex c6><k-chip outlined size="xs" centered>{{value.total}}</k-chip></k-flex>
							</k-layout>
						</k-flex>
					</k-layout>
				</div>
			</div>
		</k-flex>
		<k-flex c6>
			<div class="mt-2" v-if="stats.system.system_process">
				<span class="font-weight-medium">System processes:</span>
				<k-layout class="ks-title ks-font-size-s">
					<k-flex c4>Process</k-flex>
					<k-flex c2>CPU</k-flex>
					<k-flex c2>Mem</k-flex>
				</k-layout>
				<k-layout v-for="(data, key) in stats.system.system_process" :key="key">
					<k-flex c4>{{key}}</k-flex>
					<k-flex c2>
						<k-chip outlined size="xs" style="width: 90%">{{data.cpu.fast_percent}}%</k-chip>
					</k-flex>
					<k-flex c2>
						<k-chip outlined size="xs" style="width: 90%">{{data.memory.mem_percent}}%</k-chip>
					</k-flex>
				</k-layout>
			</div>

		<!-- Decklink devices -->

<!--		<div v-if="devices">
			<span class="font-weight-medium">Decklink devices:</span>
			<div v-for="device in devices">
				<k-chip size="xs">{{device.id}}</k-chip> {{device.name}}
			</div>
		</div>-->


		</k-flex>
	</k-layout>



		</div>
		</div>

		<div v-if="!stats">
			No statistics available
		</div>


		<div class="mt-1 mb-3" style="margin: 0 auto; text-align: left;" v-if="!small && $is_privilege(['root', 'developer']) && is_broadcaster_process_info">
			<div class="font-weight-medium">Broadcaster processes:</div>

			<k-layout>
				<k-flex c4>Name</k-flex>
				<k-flex c6>Info</k-flex>
				<k-flex c2>Count</k-flex>
			</k-layout>
			<k-divider/>
			<k-layout v-for="(count, name) in broadcaster_process_list" :key="name">
				<k-flex c4>{{ name.split("|")[0] }}</k-flex>
				<k-flex c6>{{ name.split("|")[1] }}</k-flex>
				<k-flex c2>{{ count }}</k-flex>
			</k-layout>
			<k-divider/>
			<k-layout>
				<k-flex c4>Rest</k-flex>
				<k-flex c6>&nbpsp;</k-flex>
				<k-flex c2>{{broadcaster_process.rest||0}}</k-flex>
			</k-layout>
			<k-divider/>
			<k-layout>
				<k-flex c4>Unknown</k-flex>
				<k-flex c6>&nbpsp;</k-flex>
				<k-flex c2>{{broadcaster_process.unknown||0}}</k-flex>
			</k-layout>
			<k-divider/>
			<k-layout>
				<k-flex c4>Total</k-flex>
				<k-flex c6>&nbpsp;</k-flex>
				<k-flex c2>{{broadcaster_process.total||0}}</k-flex>
			</k-layout>
		</div>

		<div v-if="selected_tab == 'stats' && instance_type == 'headend'">
			<span class="font-weight-medium">Listeners:</span>
			<headend :id="id"></headend>
		</div>

		<div v-if="selected_tab == 'stats' && instance_type == 'mediamtx'">
			<span class="font-weight-medium">Streams:</span>
			<MediaMTX :id="id" :stats="instance_stats"></MediaMTX>
		</div>

		<div v-if="selected_tab == 'stats' && instance_type == 'srt_server'">
			<span class="font-weight-medium">Clients:</span>
			<SRTServer :id="id" :stats="instance_stats"></SRTServer>
		</div>

	</div>
</template>

<script>
import InstanceModel from '@/models/instance.js';
import ChannelModel from '@/models/channel.js';
import Headend from './Headend'
import MediaMTX from './MediaMTX'
import SRTServer from './SRTServer'
import SrtStats from '@/components/stats/Srt.vue';

import datelib from '@/lib/date.js'


export default {
	props: ["id", "small", "dense", "show_title_and_channel", "on"],
	components: {
		Headend,
		MediaMTX,
		SRTServer,
		SrtStats
	},
	data() {
		var ch = this.$cloudserver.channel("instances:status:"+this.id);
		return {
			ws_channel: ch,
			show_update_status: false,
			bitrates: {},
			selected_tab: 'stats',
			quality_headers: [
				{
					text: 'Quality',
					value: 'quality',
					width: '30%',
					tooltip: 'Quality of stream'
				},
				{
					text: 'FPS',
					value: 'fps',
					width: '30%',
					tooltip: '1/s'
				},
				{
					text: 'Bitrate',
					value: 'bitrate',
					width: '40%',
					tooltip: 'kbits/s'
				},
				// {	text: 'frame', value: 'frame'},
				// {	text: 'time', value: 'time'},
				// {	text: 'url', value: 'url'},
			],
			last_stats: undefined
		}
	},
	filters: {
		format_load(load) {
			return load.toFixed(2);
		},
		format_cpu(cpu) {
			return cpu.toFixed(1);
		},
		format_version(version) {
			if (typeof(version) == "undefined") return "unknown"
			return version;
		}
	},
	created() {
	  this.ws_channel.join();
	},
	methods: {
		get_field(data, fields, default_value) {
			return _.get(data, fields, default_value);
		},
		open_channel () {
			var ch = InstanceModel.channel(this.instance);
			this.$router.push("/dashboard/channel/" + ch.uuid + "");
		},
		set_bitrate (enc, bitrate) {
			var self = this;
			var name = enc.config.name;
			InstanceModel.send_streamer(this.instance, {"type": "bitrate", "name": name, "bitrate": bitrate},(msg) => {
				self.$message.success("Streamer " + name + " bitrate changed to " + bitrate);
			}, (err) => {
				self.$message.error("Streamer " + name + " bitrate change failed");
			});
		},
		set_default_interface (ifname) {
			var self = this;
			InstanceModel.send_streamer(this.instance, {"type": "set_default_interface", "interface": ifname},(msg) => {
				self.$message.success("Default interface changed to " + ifname);
			}, (err) => {
				self.$message.error("Default interface change failed");
			});
		},
		trim_encoder_type (t) {
			var ret = t.replace("encoder.","")
/*			if (ret == "nvh265") return "h265";
			if (ret == "nvh264") return "h264";
			if (ret == "fdk_aac") return "aac";
			if (ret == "faac") return "aac";*/
			return ret;
		},
		get_encoder_config_bitrate (enc) {
			var config = enc.config;
			if (config["h264-bitrate"]) return config["h264-bitrate"];
			if (config["aac-bitrate"]) return config["aac-bitrate"];
			if (config["bitrate"]) return config["bitrate"];
			return "";
		},
		get_color (pr) {
			if (pr > 75) return "danger";
			if (pr > 60) return "warning";
			return "success";
		},
		get_cpu_color(pr) {
			var val = this.get_cpu_used(pr);
			return this.get_color(val);
		},
		get_disk_color (pr) {
			if (pr > 90) return "danger";
			if (pr > 80) return "warning";
			return "success";
		},
		get_mem_color (mem) {
			var val = this.get_mem_percent(mem);
			return this.get_color(val);
		},
		get_net_color (info, device) {
			if (!_.has(info, "ip") || info.ip == "nil") return "";
			if (device == "tun0") return "primary";
			return "success";
		},
		get_net_icon (info, device) {
			var t = info.type.toLowerCase();
			if (t == "wifi") return "wifi";
			if (t == "wired") return "settings_ethernet";
			if (t == "cellular") return "cell_tower"
			return "question_mark"
		},
		get_cpu_used(cpu) {
			return _.get(cpu, "used", cpu);
		},
		get_mem_percent (mem) {
			if(_.isObject(mem)) {
				var free = mem.free + mem.cached + mem.buffered;
				return 100 - (free / (mem.total / 100));
			}
			return mem;
		},
		get_battery_color (battery) {
			if (battery > 90) return "success";
			if (battery > 50) return "warning";
			return "danger";
		},
		get_battery_state_color (state) {
			if (state == "Charging") return "success";
			if (state == "Full") return "success";
			return "warning";
		},
		get_battery_icon (battery) {
			if (battery == 100) return 'battery_full'
			if (battery > 90) return 'battery_6_bar';
			if (battery > 75) return 'battery_5_bar';
			if (battery > 40) return 'battery_4_bar';
			if (battery > 20) return 'battery_3_bar';
			return "battery_1_bar";
		},
		get_temp_color (temp) {
			if (temp == "Nominal") return "success";
			return "warning";
			if (temp < 30) return "success";
			if (temp < 40) return "warning";
			return "danger";
		}
	},
	computed: {
		system_type() {
			return _.get(this.stats, "system.type");
		},
		cpu_count() {
			return Object.values(this.stats.system.cpu).length;
		},
		cpu_average() {
			var values = Object.values(this.stats.system.cpu);
			var ret = 0;
			_.each(values, (c) => {
				ret = ret + this.get_cpu_used(c);
			});
			ret = (ret / this.cpu_count);
			return ret;
		},
		cpu_max() {
			var values = Object.values(this.stats.system.cpu);
			var ret = _.maxBy(values, (c) => { return this.get_cpu_used(c); });
			return this.get_cpu_used(ret);
		},

		instance () {
			return InstanceModel.instance_by_id(this.id);
		},
		instance_type() {
			return _.get(this.instance, "type");
		},
		is_server() {
			if (["headend","srt_server","mediamtx","analyzer"].includes(this.instance_type)) return true;
			return false;
		},
		streamer_status () {
			var st = this.stats;
			if (typeof(st) != "undefined" && st.instance != null && typeof(st.instance) != "undefined") {
				return st.instance.streamer_state;
			}
			return false;
		},
		streamer_version () {
			var st = this.stats;
			if (typeof(st) != "undefined" && st.instance != null && typeof(st.instance) != "undefined") {
				if (typeof(st.instance.streamer_version) != "undefined" && st.instance.streamer_version != null) {
					return st.instance.streamer_version;
				}
			}
			return "";
		},
		broadcaster_version () {
     		return InstanceModel.version(this.instance);
		},
		streamer_status_text () {
			var ret = "Unknown";
			if(this.streamer_status == false) ret = "Not running";
			if(this.streamer_status) ret = "Running";
			return this.streamer_version + " | " + ret; 
		},
		streamer_status_color () {
			if(this.streamer_status == false) return "danger";
			if(this.streamer_status) return "success";
			return "warning";
		},

 		update_status_color(update_status) {
      		if (this.update_status.status == 0) return "success";
      		return "danger";
    	},
		update_status () {
      		var st = this.stats;
      		if (typeof(st) != "undefined" && st.instance != null && typeof(st.instance) != "undefined") {
        		if (typeof(st.instance.streamer_update_info) != "undefined") {
          			var info = st.instance.streamer_update_info;
          			return {
           				"time": datelib.format_date(info.timestamp) + " - " + datelib.format_time(info.timestamp),
            			"status": info.status || 0,
            			"message": info.message || []
          			}
        		}
      		}
      		return "";
    	},
		devices() {
			return _.get(this.stats, "system.devices");
		},
		stats () {
			var st = this.ws_channel.data;
			if (!_.isEmpty(st)) {
				return st;
			}
			return;
		},
		instance_stats() {
			return _.get(this.stats, "instance", {});
		},
		title () {
			return InstanceModel.title(this.instance);
		},
		channel_title_for_instance () {
			var ch = InstanceModel.channel(this.instance);
			return ChannelModel.title(ch);
		},
		rtmp_state() {
			if( !this.stats ) return
			if( !this.stats.instance ) return
			if( !this.stats.instance.rtmp_state ) return

			var urls = Object.keys(this.stats.instance.rtmp_state)
			return urls.map(url => {
				return {
					...this.stats.instance.rtmp_state[url].data,
					url,
					quality: this.stats.instance.rtmp_state[url].quality
				}
			})
		},

		srt_state() {
			if( !this.stats ) return;
			if( !this.stats.instance ) return;
			if( !this.stats.instance.srt_state ) return;

			var stats = _.filter(this.stats.instance.srt_state, (state, url) => {
				return state.data_type != "router" && url != "__";
			})

			if (_.isEmpty(stats)) return;

			return stats;

/*			var urls = Object.keys(this.stats.instance.srt_state)
			console.log(this.stats.instance.srt_state);
			return urls.map(url => {
				return {
					...this.stats.instance.srt_state[url].data,
					url,
					quality: this.stats.instance.srt_state[url].quality
				}
			})*/
		},

		srt_state_router() {
			if( !this.stats ) return;
			if( !this.stats.instance ) return;
			if( !this.stats.instance.srt_state ) return;

			var stats = _.filter(this.stats.instance.srt_state, (state, url) => {
				return state.data_type == "router" && url != "__";
			})

			if (_.isEmpty(stats)) return;

			return stats;

		},

		srtla_state() {
			if( !this.stats ) return
			if( !this.stats.instance ) return
			if( !this.stats.instance.srtla_state ) return

			var urls = Object.keys(this.stats.instance.srtla_state)
			return urls.map(url => {
				return {
					data: this.stats.instance.srtla_state[url].data,
					url,
					quality: this.stats.instance.srtla_state[url].quality
				}
			})
		},



		input_routers_state() {
			if ( !this.stats ) return;
			if ( !this.stats.instance) return;
			if ( !this.stats.instance.input_routers) return;
			return this.stats.instance.input_routers;
		},
		output_state() {
			if ( !this.stats ) return;
			if ( !this.stats.instance) return;
			if ( !this.stats.instance.outputs) return;
			return this.stats.instance.outputs;
		},


		streamer_module_state() {
			if ( !this.stats) return;
			if ( !this.stats.instance) return;
			if ( !this.stats.instance.streamer_module) return;

			return this.stats.instance.streamer_module;
		},
		streamer_net_stats()  {
			if (!this.streamer_module_state) return;
			var ret = _.find(this.streamer_module_state, function(mod) {
				return mod.type == "network_monitor";
			});
			if (typeof(ret) != "undefined") {
				return ret.state;
			}
			return {};
		},
		encoders() {
			if (!this.streamer_module_state) return;
			return _.filter(this.streamer_module_state, function(mod) {
				return mod.type == "encoder";
			});
		},
		is_broadcaster_process_info() {
			return _.isObject(_.get(this.stats, "system.process_info"));
		},
		broadcaster_process_info() {
			return _.reduce(_.get(this.stats, "system.process_info", {}), (result, count, name) => {
				if(name != "total" && name != "rest" && name != "unknown") {
					result.push({name: name, count: count})
				}
				return result;
			}, []);
		},
		broadcaster_process() {
			return _.get(this.stats, "system.process_info", {});
		},
		broadcaster_process_list() {
			return this.broadcaster_process.list||[];
		}
		// sorted_rtmp_state() {
		// 	if(!this.rtmp_state) return

		// 	return [...this.rtmp_state].sort((a, b) => {
		// 		parseInt(a.quality.split('p')[0])
		// 		- parseInt(b.quality.split('p')[0])
		// 		- b.quality.split('p')[1] == 'aux' ? -1 : 0;
		// 	})
		// }
	}
}
</script>

<style lang="css" scoped>
	.quality-table {
		width: 100%;
		margin: 0 auto;
	}

	.quality-table__row {
		width: 100%;
		margin: 3px auto;
		border-radius: 15px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		cursor: default;
		/* background-color: rgba(0, 0, 0, 0.2) */
		padding: 1px 0 0 1px;
	}

	.quality-table__row--light {
		background-color: #eee;
	}

	.quality-table__row--dark {
		background-color: rgb(54, 54, 54);
	}

	.quality-table__value {
		padding-top: 5px;
		text-align: center;
	}

	.quality-table__header {
		width: 100%;
		margin: 3px auto;
		border-radius: 15px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}

	.quality-table__header__value {
		text-align: center;
		font-size: var(--ks-font-size-s);
		cursor: pointer;
	}
</style>
